import { render, staticRenderFns } from "./UserRegMainComponent.vue?vue&type=template&id=518866bb&scoped=true"
import script from "./UserRegMainComponent.vue?vue&type=script&lang=js"
export * from "./UserRegMainComponent.vue?vue&type=script&lang=js"
import style0 from "./UserRegMainComponent.vue?vue&type=style&index=0&id=518866bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518866bb",
  null
  
)

export default component.exports